// Lightweight CLI syntax tokenizer for FortiOS / Cisco IOS configs.
const KEYWORDS = new Set([
  "config", "edit", "next", "end", "set", "unset", "interface", "crypto",
  "router", "hostname", "neighbor", "tunnel", "network", "profile", "zone",
  "service", "config-transform", "no", "keyring", "peer",
]);

const MASTER =
  /("(?:[^"]*)")|(\b\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(?:\/\d{1,2})?\b)|(\b\d+\b)|([A-Za-z][\w-]*)/g;

// Returns array of { text, cls } tokens for a single line.
export function tokenizeLine(line) {
  const trimmed = line.trimStart();
  if (trimmed.startsWith("#") || trimmed.startsWith("!")) {
    return [{ text: line, cls: "text-zinc-600 italic" }];
  }

  const tokens = [];
  let last = 0;
  let m;
  MASTER.lastIndex = 0;
  while ((m = MASTER.exec(line)) !== null) {
    if (m.index > last) tokens.push({ text: line.slice(last, m.index), cls: "text-zinc-500" });
    if (m[1]) tokens.push({ text: m[1], cls: "text-emerald-400" });
    else if (m[2]) tokens.push({ text: m[2], cls: "text-amber-300" });
    else if (m[3]) tokens.push({ text: m[3], cls: "text-orange-300" });
    else if (m[4]) {
      const w = m[4];
      tokens.push({ text: w, cls: KEYWORDS.has(w) ? "text-cyan-400" : "text-zinc-200" });
    }
    last = MASTER.lastIndex;
  }
  if (last < line.length) tokens.push({ text: line.slice(last), cls: "text-zinc-500" });
  return tokens;
}
